import { Link } from "react-router-dom";
import { CalendarCheck, MessageCircle, Phone } from "lucide-react";
import { mediaUrl } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { useBi } from "../../lib/customer";
import { useSite } from "../../lib/site";
import { waLink } from "../../lib/format";
import { Reveal } from "../Common";

export function CtaBand({ image }) {
  const b = useBi();
  const { tr } = useI18n();
  const { settings: s } = useSite();
  const ph = s?.placeholders || {};
  const call = s && !ph.phone ? (s.mobiles?.[0] || s.phone) : null;
  return (
    <section data-testid="home-cta-band" className="on-media grain relative overflow-hidden bg-brand py-28 lg:py-36">
      {image && <img src={mediaUrl(image)} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />}
      <div className="absolute inset-0 bg-gradient-to-r from-brand via-brand/85 to-brand/40 rtl:bg-gradient-to-l" aria-hidden="true" />
      <div className="mashrabiya absolute inset-y-0 end-0 w-1/2 opacity-[0.08]" aria-hidden="true" />
      <div className="container-lux relative">
        <Reveal className="max-w-3xl">
          <p className="eyebrow mb-6">{tr(s, "tagline")}</p>
          <h2 data-testid="home-cta-title" className="h-display text-4xl leading-tight sm:text-5xl lg:text-6xl">{b("Book a private viewing", "احجز معاينة خاصة")}</h2>
          <p className="mt-6 max-w-xl text-base text-fg/75 md:text-lg">{b("Walk through a home with one of our consultants — in person or virtually, at a time that suits you.", "تجوّل في منزلك القادم برفقة أحد مستشارينا — حضورياً أو افتراضياً، في الوقت المناسب لك.")}</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/schedule-viewing" data-testid="final-cta-schedule" className="btn-cta"><CalendarCheck className="h-4 w-4" />{b("Schedule Viewing", "احجز معاينة")}</Link>
            {s?.whatsapp && !ph.whatsapp && <a href={waLink(s.whatsapp, b("Hello, I'd like to book a private viewing.", "مرحباً، أود حجز معاينة خاصة."))} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp" className="btn-ghost"><MessageCircle className="h-4 w-4" />{b("WhatsApp", "واتساب")}</a>}
            {call && <a href={`tel:${call.replace(/\s/g, "")}`} data-testid="final-cta-call" className="btn-ghost"><Phone className="h-4 w-4" /><span dir="ltr">{call}</span></a>}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
